<template>
    <div class="editable-settings__input-wrapper" @keydown.capture="onWrapperKeyDown">
        <slot name="label" />
        <Input
            ref="inputEl"
            :model-value="modelValue"
            type="number"
            class="editable-settings__input"
            size="small"
            :class="{ 'editable-settings__input--with-suffix': showSuffix }"
            :placeholder="placeholder"
            @onChange="onChange"
        >
            <template #append>
                <span v-show="showSuffix">{{ suffix }}</span>
            </template>
        </Input>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        modelValue: {
            type: Number,
            default: undefined
        },
        placeholder: {
            type: String
        },
        suffix: {
            type: String,
            default: "px"
        },
        showSuffix: {
            type: Boolean,
            default: false
        }
    },

    emits: ["on-change", "wrapperKeyDown", "update:modelValue"],

    methods: {
        onChange(event: InputEvent) {
            const value = (event.target as HTMLInputElement).value;

            if (value === "" || isNaN(Number(value))) {
                this.$emit("update:modelValue", undefined);
                return;
            }

            this.$emit("update:modelValue", Number(value));
        },

        getMoveByValue(event: KeyboardEvent, step = 1) {
            let moveBy = event.key === "ArrowLeft" || event.key === "ArrowUp" ? step : -step;

            if (event.shiftKey) {
                moveBy *= 10;
            }

            return moveBy;
        },

        onWrapperKeyDown(event: KeyboardEvent) {
            if (!["ArrowUp", "ArrowDown"].includes(event.key)) {
                return;
            }
            event.preventDefault();
            event.stopImmediatePropagation();

            const moveBy = this.getMoveByValue(event);
            const currentValue = this.modelValue || (this.placeholder ? parseFloat(this.placeholder) : 0);

            this.$emit("update:modelValue", currentValue + moveBy);
        }
    }
});
</script>
